import { Col, DatePicker, Row, Table, Typography } from 'antd'
import dayjs, { Dayjs } from 'dayjs'
import { FC, useMemo, useState } from 'react'
import PageLayout from '../../../components/page-layout/page-layout'
import TableWrapper from '../../../components/table-wrapper/table-wrapper'
import useErrorModal from '../../../hooks/api/use-error-modal'
import {
    useDeleteOvertimeMutation,
    useGetOvertimesQuery,
} from '../../../store/api/overtimes-api'
import Overtime from '../../../types/api/overtime'
import { EndpointQueryParameters } from '../../../types/strapi/strapi'
import AddOvertimeForm from './components/add-overtime-form'
import { getColumns } from './constants/columns'

function buildQueryParams(month: Dayjs): EndpointQueryParameters {
    return {
        filters: {
            date: {
                $gte: month.startOf('month').format('YYYY-MM-DD'),
                $lte: month.endOf('month').format('YYYY-MM-DD'),
            },
        },
        populate: {
            user: {
                populate: {
                    created_by_permissions_user: {
                        fields: ['username'],
                    },
                    updated_by_permissions_user: {
                        fields: ['username'],
                    },
                },
            },
        },
        sort: ['date:desc'],
        pagination: {
            page: 1,
            pageSize: 100,
        },
    }
}

const OvertimePage: FC = () => {
    const [month, setMonth] = useState<Dayjs>(() => dayjs())
    const queryParams = useMemo(() => buildQueryParams(month), [month])
    const { data, isLoading } = useGetOvertimesQuery(queryParams)
    const [deleteOvertime, deleteState] = useDeleteOvertimeMutation()

    useErrorModal(deleteState, 'Ошибка удаления переработки')

    const dataSource = data?.data || []
    const totalHours = dataSource.reduce((sum, item) => sum + (Number(item.hours) || 0), 0)

    const handleDelete = async (overtime: Overtime) => {
        await deleteOvertime(overtime.documentId).unwrap()
    }

    return (
        <PageLayout title={'Переработки'}>
            <Row align='middle' gutter={24} justify='space-between'>
                <Col>
                    <AddOvertimeForm />
                </Col>
                <Col>
                    <Row align='middle' gutter={12}>
                        <Col>
                            <Typography.Text>Месяц:</Typography.Text>
                        </Col>
                        <Col>
                            <DatePicker
                                picker='month'
                                value={month}
                                onChange={value => value && setMonth(value)}
                                allowClear={false}
                            />
                        </Col>
                        <Col>
                            <Typography.Text>
                                Сумма часов:{' '}
                                <Typography.Text strong>{totalHours}</Typography.Text>
                            </Typography.Text>
                        </Col>
                    </Row>
                </Col>
            </Row>

            <TableWrapper style={{ flex: 'auto' }}>
                <Table
                    bordered
                    columns={getColumns({
                        onDelete: handleDelete,
                        isDeleting: deleteState.isLoading,
                    })}
                    dataSource={dataSource}
                    loading={isLoading}
                    pagination={false}
                    rowKey='documentId'
                    size='small'
                />
            </TableWrapper>
        </PageLayout>
    )
}

export default OvertimePage
